/* eslint-disable @typescript-eslint/no-explicit-any */
import { parse, stringify } from "query-string"

export function parseQuery(params: string): any {
  return parse(params, {
    arrayFormat: "comma",
    parseBooleans: true,
    parseNumbers: true,
  })
}

export function stringifyQuery(data: any) {
  return stringify(data, {
    arrayFormat: "comma",
  })
}
